import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxPopupNotificationData } from "./bfx-popup-notification-data.model";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { BfxBlotterInterventionContextMenuApprovalState } from "shared/cubiq-services";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";

export class BfxPopupCreditFailFillAndRejectedNotificationData extends BfxPopupNotificationData {
  public itemState: BfxBlotterInterventionContextMenuApprovalState;

  constructor(
    private activeUser: CubiqServices.ActiveUser,
    private hasDISalesApprove,
    private hasDISalesReject,
    private hasDISalesUnrestricted,
    public subType: BFXNotificationSubType,
  ) {
    super(BFXNotificationType.DEALER_INTERVENTION, "icon-bfx_credit_failed", subType);
    this.itemState = new BfxBlotterInterventionContextMenuApprovalState();
    this.itemState.actionRequests = {
      approve: {
        approval: new Map<CubiqTS.SalesApprovalAction, string[]>(),
      },
      accept: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
      },
      reject: {
        approval: new Map<CubiqTS.SalesApprovalAction, string[]>(),
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
      },
    };
  }

  reInitMaps() {
    this.itemState.actionRequests.approve.approval.clear();
  }

  private addToAcceptMap(orderId: string) {
    if (!this.itemState.actionRequests.approve.approval.has(CubiqTS.SalesApprovalAction.APPROVE)) {
      this.itemState.actionRequests.approve.approval.set(CubiqTS.SalesApprovalAction.APPROVE, []);
    }
    this.itemState.actionRequests.approve.approval
      .get(CubiqTS.SalesApprovalAction.APPROVE)
      .push(orderId);
  }

  protected updateAllowableActions() {
    this.actions = [];
    this.reInitMaps();
    let approveCount: number = 0;
    let rejectCount: number = 0;

    this.payload.forEach((item) => {
      if (this.hasDISalesUnrestricted || this.hasDISalesApprove) {
        approveCount++;
        this.addToAcceptMap(item.orderId);
      }
    });

    if (approveCount == this.payload.length) {
      this.actions.push({
        label: "Approve",
        command: BfxPopupNotificationCommand.POPUP_INTERVENTION_APPROVE,
        icon: "",
        styleClass: "bfx-context-menu-item-enabled",
      });
    }
  }

  destroy() {
    super.destroy();
    this.activeUser = null;
  }
}
